<div class="container-fluid">
    <div class="row text-center container-items">
        <span class="previo p-0" (click)="seleccionPagina(seleccionada - 1)" style="cursor: pointer;"><img
                src="assets/img/icon/arrowLeft.svg" alt=""></span>
        <div *ngFor="let pagina of paginas; let i = index" style="max-width: fit-content;margin: 0px; padding: 0px;">
            <div class="pagina" *ngIf="i < 7 || i === paginas.length - 1" (click)="seleccionPagina(pagina)"
                style="cursor: pointer;" [ngClass]="seleccionada === pagina ? 'activo' : ''">
                {{pagina}}
            </div>
            <div class="pagina" *ngIf="i >= 7 && seleccionada === pagina && i !== paginas.length - 1"
                (click)="seleccionPagina(pagina)" style="cursor: pointer;"
                [ngClass]="seleccionada === pagina ? 'activo' : ''">
                {{pagina}}
            </div>
        </div>
        <span class="siguiente p-0" (click)="seleccionPagina(seleccionada + 1)" style="cursor: pointer;"><img
                src="assets/img/icon/arrowRight.svg" alt=""></span>
    </div>
</div>